import React, { createContext, useContext, useEffect, useRef } from 'react';
import { useHistory } from 'react-router';
import { LocationListener, LocationState } from 'history';

export const ScrollBehaviourContext = createContext(true);

export const ScrollBehaviourProvider: React.FC<{
  children: JSX.Element | JSX.Element[];
}> = props => {
  const history = useHistory();
  const shouldScrollToTop = useRef(true);

  // Current behaviour is that we never scroll to top if a POP action
  // happens. That way we let the browser use its automatic scroll restoration
  const handleHistoryChange: LocationListener<LocationState> = (
    location,
    action
  ) => {
    shouldScrollToTop.current = action !== 'POP';
  };

  useEffect(() => {
    const unlisten = history.listen(handleHistoryChange);

    return unlisten;
  }, [history]);

  return (
    <ScrollBehaviourContext.Provider value={shouldScrollToTop.current}>
      {props.children}
    </ScrollBehaviourContext.Provider>
  );
};

export const ScrollToTop: React.FC<{ children: JSX.Element }> = props => {
  const shouldScrollToTop = useContext(ScrollBehaviourContext);

  useEffect(() => {
    if (shouldScrollToTop) {
      window.scroll(0, 0);
    }
  }, [shouldScrollToTop]);

  return props.children;
};
